import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { register } from "../../api/auth";
import { Checkbox, FormControlLabel, TextField, Typography, useTheme } from "@mui/material";
import Button from "@mui/material/Button";
import { ThemeProvider } from "@mui/material/styles";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import { Form, LoginContainer, StyledBox } from "../Login/Login.styled";

export function Register() {
    const navigate = useNavigate();
    const theme = useTheme();

    const [formData, setFormData] = useState({
        first_name: "",
        email: "",
        password: "",
        password_verification: "",
    });
    const [error, setError] = useState<string | null>(null);
    const [success, setSuccess] = useState<boolean>(false);

    function handleInputChange(e: React.ChangeEvent<HTMLInputElement>) {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value,
        });
    }

    //Переписать, добавить обработку ошибок через Алерт Сервис
    async function handleSubmit(e: React.FormEvent) {
        e.preventDefault();
        setError(null);
        setSuccess(false);

        if (formData.password !== formData.password_verification) {
            setError("Passwords do not match");
            return;
        }

        try {
            await register(formData.first_name, formData.email, formData.password, formData.password_verification);
            setSuccess(true);
            setFormData({ first_name: "", email: "", password: "", password_verification: "" });
            navigate("/pairs");
        } catch {
            setError("An error occurred during registration");
        }
    }

    return (
        <ThemeProvider theme={theme}>
            <StyledBox>
                <LoginContainer>
                    <Typography variant="h5" align="center" gutterBottom>
                        Create User
                    </Typography>
                    <Typography variant="body2" align="center" gutterBottom sx={{ mb: 2 }}>
                        Create a new account to get started
                    </Typography>
                    {error && <Typography color="error">{error}</Typography>}
                    {success && <Typography color="success">Registration successful!</Typography>}
                    <Form onSubmit={handleSubmit}>
                        <TextField label="First Name" name="first_name" variant="outlined" fullWidth value={formData.first_name} onChange={handleInputChange} required />
                        <TextField label="Email" name="email" variant="outlined" fullWidth value={formData.email} onChange={handleInputChange} required />
                        <TextField label="Password" name="password" type="password" variant="outlined" fullWidth value={formData.password} onChange={handleInputChange} required />
                        <TextField label="Confirm Password" name="password_verification" type="password" variant="outlined" fullWidth value={formData.password_verification} onChange={handleInputChange} required />
                        <FormControlLabel control={<Checkbox />} label="I agree to the terms and conditions" />
                        <Button type="submit" variant="contained" fullWidth sx={{ backgroundColor: "#90caf9", color: "#000" }} endIcon={<PersonAddIcon />}>
                            Register
                        </Button>
                    </Form>
                </LoginContainer>
            </StyledBox>
        </ThemeProvider>
    );
}
